<template>
  <div style="height:100%;">
    <swiper :options="swiperOption" v-if="homeSlides[0] && homeSlides[0].image">
      <swiper-slide v-for="(slide, index) in homeSlides" :key="index">
        <img :src="slide.image" />
        <div class="slider_trans">
          <div class="slider-caption">
            <h2
              data-swiper-parallax="-100%"
              :style="{ color: customization.mainColor, 'font-size': '1.5em' }"
            >
              {{ slide.slideTitle }}
            </h2>
            <span class="subtitle" data-swiper-parallax="-60%">{{
              slide.slideSubTitle
            }}</span>
            <p data-swiper-parallax="-30%" style="margin-top:0px;">
              {{ slide.slideText }}
            </p>
          </div>
        </div>
        <div class="slide-overlay"></div>
      </swiper-slide>
    </swiper>
    <div
      class="swiper-pagination"
      slot="pagination"
      :style="[bottomPosition]"
    ></div>
    <component :is="bottomMenuComponent" :referralsCount="historyLoaded ? referralsCount : null"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BottomPanelMenu from '../home-page-components/bottom-panel-menu.component'
import CircleMenu from '../home-page-components/circle-menu.component'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { homePageMenuType } from '../../shared/enums/menu.type'
import {referralsCounterHelper} from '@/helpers/referral-history.helper'

export default {
  name: 'varius-component',
  components: {
    'bottom-panel': BottomPanelMenu,
    'circle-menu': CircleMenu,
    swiper: swiper,
    'swiper-slide': swiperSlide
  },
  mounted: function () {
    // setTimeout(
    //   () => {
    //     var bullets = document.getElementsByClassName(
    //       'swiper-pagination-bullet'
    //     )
    //     for (var bul of bullets) {
    //       bul.style.background = 'red'// this.customization.fontColor
    //     }
    //   },
    //   1000
    // )
  },
  computed: {
    ...mapState({
      pageEnum: (state) => state.about.pagesEnum,
      isDemoUser: (state) => state.editUserProfile.customerUser.isDemoUser,
      homeSlides: (state) => state.common.homeImages,
      salesPersonFullName: (state) => state.common.salesPersonFullName,
      salesTitle: (state) => state.common.salesTitle,
      salesPersonPhone: (state) => state.common.phone,
      companyName: (state) => state.common.companyName,
      salesBio: (state) => state.common.salesBio.substring(0, 200),
      customization: (state) => state.common.customization,
      referralsCount: (state) => referralsCounterHelper(state.recommendFriend.historyCount)
    }),
    ...mapGetters({
      historyLoaded: 'recommendFriend/historyLoaded'
    }),
    bottomMenuComponent () {
      return this.customization.homePageMenuId ===
        homePageMenuType.bottomPanel ||
        this.customization.homePageMenuId === homePageMenuType.bottomList
        ? 'bottom-panel'
        : 'circle-menu'
    },
    bottomPosition () {
      let bottom
      switch (this.customization.homePageMenuId) {
        case homePageMenuType.bottomPanel:
          bottom = 80
          break
        case homePageMenuType.bottomList:
          bottom = 275
          break

        default:
          bottom = 20
          break
      }
      return { bottom: `${bottom}px` }
    }
  },
  data () {
    return {
      homePageMenuType: homePageMenuType,
      swiperOption: {
        parallax: true,
        pagination: '.swiper-pagination'
      }
    }
  }
}
</script>
<style scoped>
.page-content {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
  overflow: hidden !important;
  background-color: #000;
}
.slider-caption {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
}
.slider-caption > span {
  color: white;
}
.active span {
  display: block;
}
.swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
}
</style>
<style>
.swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  display: inline-block;
  border: solid 1px #000;
  margin-right: 2px;
}
.page-content {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
  overflow-x: hidden !important;
}
.low-caption {
  top: auto;
  bottom: 25%;
}
.slider_trans {
  background: rgba(0, 7, 15, 0.1) !important;
}
.swiper-slide img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.slider_trans {
  -webkit-box-shadow: inset 0px 51px 61px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: inset 0px 51px 61px 0px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0px 51px 61px 0px rgba(0, 0, 0, 0.2);
}

.swiper-slide {
  position: relative;
}
.slide-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    0deg,
    rgb(0 0 0 / 0) 80%,
    rgb(0 0 0 / 30%) 90%
  );
}
</style>



// WEBPACK FOOTER //
// varius-component.vue?4edbce41